import React from 'react'
import PropTypes from 'prop-types'
import { isPlus, SmsAutoRefillToggle } from './'
import './SmsMeteredInfo.less'
import { path } from 'ramda'

function SmsMeteredInfo({ user, userActions }) {
  // Only show for AWN+ subscribers (individual or teams)
  if (!isPlus(user)) {
    return null
  }

  return (
    <div className='payment-sms-metered-info'>
      <h3>AWN+ SMS alerts</h3>
      <p>Automatically add 100 SMS for $1.50 when your available messages are depleted. ($1.50 per 100 SMS / Monthly billed)</p>
      <div className='details'>
        <SmsAutoRefillToggle user={user} userActions={userActions} />
        <div className='info'>
          <strong>AWN+ SMS Bank</strong>: {path(['info', 'smsBank'], user) || 0}<br/>
          <strong>Metered SMS Bank</strong>: {path(['info', 'smsBankMetered'], user) || 0}<br/>
          {/* <strong>Refills this month</strong>: TODO<br/> */}
        </div>
      </div>
    </div>
  )
}

SmsMeteredInfo.propTypes = {
  user: PropTypes.object.isRequired,
  userActions: PropTypes.object.isRequired
}

SmsMeteredInfo.defaultProps = {}

SmsMeteredInfo.displayName = 'SmsMeteredInfo'

export default SmsMeteredInfo